/**
 * Helpers puros de entradas de cola y empleados del gestor
 */
import { ENTRADA_SIN_PEDIDO_MARCA, ETIQUETAS_ENTRADA_ESTADO } from "../constants";

const SIN_NOMBRE = "(sin nombre)";

/**
 * Indica si un número de turno corresponde a una entrada sin pedido
 * (sustituye a entrada_sin_pedido del modelo EntradaCola)
 */
export const esEntradaSinPedido = (numero) =>
    numero !== null && numero !== undefined && String(numero).includes(ENTRADA_SIN_PEDIDO_MARCA);

/**
 * Devuelve una lista nueva con la entrada actualizada en su posición (por id),
 * sin mutar la original. Si no existe la entrada, la lista se devuelve igual.
 */
export const reemplazarEntrada = (entradas, actualizada) =>
    entradas.map((entrada) => (entrada.id === actualizada.id ? actualizada : entrada));

/**
 * Etiqueta legible de un estado de entrada; tolera estados desconocidos o vacíos
 * (devuelve el texto recibido capitalizado, o '-' si no hay)
 */
export const generarEtiquetaEstado = (estado) => {
    if (estado === null || estado === undefined || estado === "") return "-";
    const conocido = ETIQUETAS_ENTRADA_ESTADO[estado];
    if (conocido) return conocido.label;
    const texto = String(estado);
    return texto.charAt(0).toUpperCase() + texto.slice(1);
};

const codigoEmpleado = (empleado) => empleado?.ID ?? empleado?.id ?? empleado?.codigo ?? null;
const nombreEmpleado = (empleado) => empleado?.NOMBRE ?? empleado?.nombre ?? empleado?.displayName ?? "";
const tieneCodigo = (empleado) => codigoEmpleado(empleado) !== null;
const esIdVacio = (id) => id === null || id === undefined || id === "";

/**
 * Resuelve el empleado seleccionado tolerando las formas ID/id/codigo y
 * NOMBRE/nombre/displayName. Devuelve { codigo: null, nombre: '' } si no existe,
 * si el id es null/undefined/'' o si el empleado no tiene código.
 */
export const resolverEmpleado = (empleados, empleadoId) => {
    const sinResolver = { codigo: null, nombre: "" };
    if (esIdVacio(empleadoId)) return sinResolver;
    const lista = Array.isArray(empleados) ? empleados : [];
    const encontrado = lista
        .filter(tieneCodigo)
        .find((empleado) => String(codigoEmpleado(empleado)) === String(empleadoId));
    if (!encontrado) return sinResolver;
    return { codigo: codigoEmpleado(encontrado), nombre: nombreEmpleado(encontrado) };
};

/**
 * Opciones { value, label } para el selector de empleados (omite los que no tienen código)
 */
export const opcionesEmpleado = (empleados) =>
    (Array.isArray(empleados) ? empleados : []).filter(tieneCodigo).map((empleado) => ({
        value: String(codigoEmpleado(empleado)),
        label: nombreEmpleado(empleado) || SIN_NOMBRE,
    }));
